import { API_BASE, createHeaders } from "./apiClient";
import { getCurrentUserId } from "./authService";

// A member's proposal for a chapter of "A story in a chart": text, links and
// files in one multipart request. The browser sets the multipart boundary,
// so no Content-Type header is sent.
export async function submitStoryProposal({ title, description, links, files = [] }) {
  const form = new FormData();
  form.append("title", title);
  form.append("description", description || "");
  form.append("links", links || "");
  files.forEach((f) => form.append("files", f, f.name));
  const res = await fetch(`${API_BASE}/api/story-submissions`, {
    method: "POST",
    headers: createHeaders({ json: false, userId: getCurrentUserId() }),
    body: form,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.error || `Could not send (${res.status})`);
  return data;
}
